import { onboardingRegistrationAccessHelper } from 'legacy/lut/classes/helpers/OnboardingRegistrationAccessHelper'

interface IRegistrationLoginViaToken {
  token: string
  requestId: number
}

export const registrationLoginViaToken = async ({
  token,
  requestId,
}: IRegistrationLoginViaToken) => {
  const { warningMessage, hasAccess, email } =
    await onboardingRegistrationAccessHelper.isTokenValid(token, requestId)
  if (warningMessage) {
    return { warningMessage }
  }

  return { allowRedirect: hasAccess, redirectRequestId: requestId, email }
}
